import Crud from "../Crud";
import MUIOrangeColor from "@mui/material/colors/orange";

/**
 * Static helper functions related to Locations.
 */
export default class Location extends Crud {
  /**
   * @param {object} location The location object.
   * @returns The display name of the location.
   */
  static getDisplayName(location) {
    return location ? location.name : null;
  }

  /**
   * Determines if a location matches a search query.
   *
   * @param {object} location The location to test.
   * @param {string} query The search query.
   * @returns {boolean} Whether or not the location matches the query.
   */
  static match(location, query) {
    return (
      (location.name !== null && location.name.toLowerCase().includes(query)) ||
      location.id === +query
    );
  }

  /**
   * @param {array} locations The list to sort.
   * @returns {array} The sorted list.
   */
  static sort(locations) {
    return locations.sort((a, b) => {
      return a.name.localeCompare(b.name);
    });
  }

  /**
   * @returns {string} The color of this object.
   */
  static getBaseColor() {
    return MUIOrangeColor;
  }

  /**
   * @returns {string} The icon name for this object.
   */
  static getIconName() {
    return "LocationCity";
  }
}
